import { render, staticRenderFns } from "./NewsPostImages.vue?vue&type=template&id=08e50aa0&scoped=true"
import script from "./NewsPostImages.vue?vue&type=script&lang=js"
export * from "./NewsPostImages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e50aa0",
  null
  
)

export default component.exports